import request from "@/services/request";

async function getFoivs() {
    try {

        const res = await request({
            endpoint: `/api/getFoivs`,
            method: 'get'
        });
        if (res.status === 200) {

            return res.data;
        }
        else {
            throw new Error('Ошибка получения данных')
        }
    } catch (e) {
        console.log("Ошибка получения данных " + e);
    }
}

export default getFoivs
